import ShipperDetail from './styled';
export default ShipperDetail;
